import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { HighChartDonutChart } from '../../../shared';
import { NPI_ENGAGEMENT_SEGEMENT_CHART_OPTIONS } from './constants';
import { useSelector } from 'react-redux';

function NpiEngagedPieChart() {
    const { isLoading, NpiEngagedChart } = useSelector((state) => state.digitalEngagement);
    
    return (
        <Box className="container-p-24-br-16 bg-gray-50">
            <Box>
                <Typography className="text-md-medium gray-900">
                    No. of Engagements
                </Typography>
            </Box>
            {/* HighChartDonutChart */}
            {
                isLoading ? <Skeleton height={400} variant="rectangular" width='100%' /> :
                    <HighChartDonutChart
                        chartOptions={NPI_ENGAGEMENT_SEGEMENT_CHART_OPTIONS}
                        seriesData={NpiEngagedChart}
                    />
            }
        </Box>
    );
}

export default NpiEngagedPieChart;
